import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import Immutable from "immutable";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";
import Presupuestos from "./Presupuestos";
import Usuarios from "./Usuarios";

import {
  showHideModalCreate,
  guardarCenco,
  showHideModalCreatePresupuesto,
  filtrarTableLocally
} from "../actions";
import {
  showHideModalSelector,
  selectFromSelector
} from "../../Layout/actions";

class ModalCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabs: [
        { id: 0, caption: "Presupuestos", component: <Presupuestos /> },
        { id: 1, caption: "Usuarios", component: <Usuarios /> }
      ],
      selected: 0
    };
  }

  componentWillUnmount() {
    this.setState({ selected: 0 });
  }

  selectTab = (e, tab) => {
    e.preventDefault();
    this.setState({ selected: tab });
  };

  handleOpenSelector = (columns, reducer, path) => {
    const payload = {};
    const fn = a => {
      payload.reducer = reducer;
      payload.path = path;
      payload.value = Immutable.fromJS(a);
      this.props.selectFromSelector(payload);
    };
    this.props.showHideModalSelector(
      true,
      "Listado de usuarios del sistema",
      "User",
      columns,
      fn,
      []
    );
  };

  handleOnChange = value => {
    this.props.filtrarTableLocally();
  };

  modalContent = () => {
    const { tabs, selected } = this.state;
    let editable = false;
    const buttons = [];
    if (
      this.props.elementos
        .filter(x => x === "AXkmoTuy" || x === "NmtF9A7w")
        .count()
    ) {
      editable = this.props.elementos.some(x => x === "AXkmoTuy");
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="floppy-o"
          title="Guardar"
          disabled={this.props.saving}
        />
      );
    }

    const tabButtons = [];
    if (this.state.selected === 0) {
      if (this.props.elementos.filter(x => x === "AXkmoTuy").count()) {
        tabButtons.push(
          <BoxButton
            key="btn1"
            name="plus"
            title="Nuevo presupuesto"
            onClick={e => {
              e.preventDefault();
              this.props.showHideModalCreatePresupuesto(true);
            }}
          />
        );
      }
    }

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarCenco();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label className="control-label">Código</label>
                <Input
                  type="text"
                  reducer="cencos"
                  path="modalCreate.data.codigo"
                  disabled={!editable}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label className="control-label">Descripción</label>
                <Input
                  type="text"
                  reducer="cencos"
                  path="modalCreate.data.nombre"
                  disabled={!editable}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label className="control-label">Unidad de negocio</label>
                <Input
                  type="text"
                  reducer="cencos"
                  path="modalCreate.data.unidad_negocio"
                  disabled={!editable}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label className="control-label">Estado</label>
                <Input
                  type="select"
                  reducer="cencos"
                  path="modalCreate.data.activo"
                  disabled={!editable}
                  options={[
                    { value: true, caption: "ACTIVO" },
                    { value: false, caption: "INACTIVO" }
                  ]}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <label className="control-label">Aprobador</label>
                <Input
                  type="selector"
                  reducer="cencos"
                  path="modalCreate.data.aprobador.name"
                  disabled={!editable}
                  onClick={() =>
                    this.handleOpenSelector(
                      [
                        {
                          id: 1,
                          caption: "Identificación",
                          value: "username",
                          width: "30%"
                        },
                        {
                          id: 2,
                          caption: "Nombre",
                          value: "name",
                          width: "70%"
                        }
                      ],
                      "cencos",
                      "modalCreate.data.aprobador"
                    )
                  }
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <div className="row">
              <div className="col-md-12" style={{ height: "250px" }}>
                <div
                  className="row"
                  style={{ height: "100%", overflowX: "hidden" }}
                >
                  <div className="col-md-12" style={{ height: "100%" }}>
                    <div className="nav-container">
                      <div className="nav-tabs-section">
                        <ul className="nav-tabs-tabs">
                          {tabs.map(x => {
                            return (
                              <li
                                key={`li02[${x.id}]`}
                                className={selected === x.id ? "active" : ""}
                              >
                                <a onClick={e => this.selectTab(e, x.id)}>
                                  {x.caption}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="nav-main-section">
                        <div className="">
                          {this.state.selected === 0 && (
                            <ButtonStrip actions={tabButtons} />
                          )}
                          {this.state.selected === 1 && (
                            <div className="buttonstrip">
                              <Input
                                type="text"
                                reducer="cencos"
                                path="modalCreate.data.tables.users.search"
                                afterChange={this.handleOnChange}
                                placeholder="Filtrar..."
                              />
                            </div>
                          )}
                        </div>
                        <div className="nav-main-section-scrollable">
                          {tabs[selected].component}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreate } = this.props;

    return (
      <Modal
        ancho="40vw"
        mostrar={modalCreate.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de centros de costo"
        nombre="modal_create_cencos"
        onCerrarModal={() => this.props.showHideModalCreate(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreate: state.cencos.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreate,
  guardarCenco,
  showHideModalSelector,
  selectFromSelector,
  showHideModalCreatePresupuesto,
  filtrarTableLocally
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
